const WizardSectionLabel = ({ children, className = '' }) => {
  return <div className={`comp-wizard-section-label ${className}`}>{children}</div>;
};

export default WizardSectionLabel;
